<ng-container *ngIf="dipRegistrationAlertState$ | async as dipRegistrationAlertState">
  <div role="alert" aria-live="assertive" aria-atomic="true" class="td-notification"
       [ngClass]="dipRegistrationAlertState.type === 'success' ? 'bg-success' : 'bg-danger'"
       *ngIf="dipRegistrationAlertState.isEnabled">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-sm-10 mx-auto">
          <h3>
            <span class="td-icon icon-regular"
                  [ngClass]="dipRegistrationAlertState.type === 'success' ? 'td-icon-approved' : 'td-icon-error'"
                  aria-hidden="true"></span>
            <span [innerHTML]="dipRegistrationAlertState.titleKey | authTranslate :{phoneNumber: phoneNumber}"></span>
          </h3>
          <p [innerHTML]="dipRegistrationAlertState.messageKey | authTranslate :{phoneNumber: phoneNumber}"></p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<div class="container">
  <div class="row">
    <div class="col-sm-10 col-md-8 col-lg-6 mx-auto">
      <div class="row">
        <h1 class="col-10 mx-auto">{{ 'DIPRSRegistration.customerIdentification.title' | authTranslate }}</h1>
      </div>
      <p>
        <span>{{ 'DIPRSRegistration.customerIdentification.introduction' | authTranslate }}</span>
        <button type="button"
                #button
                (click)="showModal(button)"
                [title]="'DIPRSRegistration.customerIdentification.introduction.help.modal.label' | authTranslate"
                [attr.aria-label]="'DIPRSRegistration.customerIdentification.introduction.help.modal.label' | authTranslate"
                [attr.modal-title]="'DIPRSRegistration.customerIdentification.introduction.help.modal.title' | authTranslate"
                class="td-btn-unstyled td-icon-wrapper">
          <span class="td-icon icon-small td-icon-question ml-1" aria-hidden="true"></span>
        </button>
      </p>

      <div role="alert" aria-live="assertive" aria-atomic="true" class="row td-notification-section bg-danger" *ngIf="hasError">
        <div class="col-12">
          <span class="td-icon icon-small td-icon-error"></span>
          <span>{{ 'DIPRSRegistration.customerIdentification.error.fill.out.error.banner' | authTranslate }}</span>
        </div>
      </div>

      <form [formGroup]="customerIdentificationForm" class="row" novalidate autocomplete="off">
        <!-- first name -->
        <div class="col-sm-6 form-group">
          <label for="firstName">{{ 'DIPRSRegistration.customerIdentification.firstName' | authTranslate }}</label>
          <input
            [placeholder]="'DIPRSRegistration.customerIdentification.firstName.placeholder' | authTranslate"
            formControlName="firstName"
            [dipsePatternFilter]="namePattern"
            id="firstName"
            class="form-control"
            maxlength="30"
            aria-describedby="firstNameErrorMessage"
            [class.is-invalid]="getFormControl('firstName').touched && getFormControl('firstName').invalid"
            [attr.aria-invalid]="getFormControl('firstName').touched && getFormControl('firstName').invalid"
          />
          <div class="td-error" id="firstNameErrorMessage" role="alert"
               *ngIf="getFormControl('firstName').touched && getFormControl('firstName').invalid">
            <div *ngIf="getFormControl('firstName').errors.required">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.firstName.error.required' | authTranslate }}
            </div>
            <div *ngIf="getFormControl('firstName').errors.pattern">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.firstName.error.pattern' | authTranslate }}
            </div>
            <div *ngIf="customerIdentificationForm.controls['firstName'].hasError('minlength')">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.firstName.error.minLength' | authTranslate }}
            </div>
          </div>
        </div> <!-- first name -->

        <!-- last name -->
        <div class="col-sm-6 form-group">
          <label for='lastName'>{{ 'DIPRSRegistration.customerIdentification.lastName' | authTranslate }}</label>
          <input
            [placeholder]="'DIPRSRegistration.customerIdentification.lastName.placeholder' | authTranslate"
            formControlName="lastName"
            [dipsePatternFilter]="namePattern"
            id="lastName"
            class="form-control"
            maxlength="30"
            aria-describedby="lastNameErrorMessage"
            [class.is-invalid]="getFormControl('lastName').invalid && getFormControl('lastName').touched"
            [attr.aria-invalid]="getFormControl('lastName').invalid && getFormControl('lastName').touched"
          />
          <div class="td-error" id="lastNameErrorMessage" role="alert"
               *ngIf="getFormControl('lastName').invalid && getFormControl('lastName').touched">
            <div *ngIf="getFormControl('lastName').errors.required">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.lastName.error.required' | authTranslate }}
            </div>
            <div *ngIf="getFormControl('lastName').errors.pattern">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.lastName.error.pattern' | authTranslate }}
            </div>
            <div *ngIf="customerIdentificationForm.controls['lastName'].hasError('minlength')">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.lastName.error.minLength' | authTranslate }}
            </div>
          </div>
        </div> <!-- last name -->

        <!-- date of birth -->
        <div class="col-sm-10">
          <dip-registration-full-date
            formControlName="birthDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [language]="language"
            [label]="'DIPRSRegistration.customerIdentification.dateOfBirth' | authTranslate"
            class="form-row"
            aria-describedby="birthDateErrorMessage"
            ></dip-registration-full-date>

          <div class="td-error mt-n30 mb-30" role="alert" id="birthDateErrorMessage"
               *ngIf="getFormControl('birthDate').errors &&
                      getFormControl('birthDate').invalid &&
                      getFormControl('birthDate').touched">
            <div *ngIf="getFormControl('birthDate').errors.required">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.dateOfBirth.error.required' | authTranslate }}
            </div>
          </div>
        </div> <!-- date of birth -->

        <!-- postal code -->
        <div class="col-12">
          <label for="postalCode">{{ 'DIPRSRegistration.customerIdentification.postalCode' | authTranslate }}</label>
        </div>
        <div class="col-sm-4 form-group">
          <input
            [placeholder]="'DIPRSRegistration.customerIdentification.postalCode.placeholder' | authTranslate"
            formControlName="postalCode"
            [imask]="postalCodeMaskOptions"
            id="postalCode"
            class="form-control"
            aria-describedby="postalCodeErrorMessage"
            [class.is-invalid]="getFormControl('postalCode').errors &&
                                getFormControl('postalCode').invalid &&
                                getFormControl('postalCode').touched"
            [attr.aria-invalid]="getFormControl('postalCode').errors &&
                                 getFormControl('postalCode').invalid &&
                                 getFormControl('postalCode').touched"
          />

          <div class="td-error" role="alert" id="postalCodeErrorMessage"
               *ngIf="getFormControl('postalCode').errors &&
                      getFormControl('postalCode').invalid &&
                      getFormControl('postalCode').touched">

            <div *ngIf="getFormControl('postalCode').errors.required">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.postalCode.error.required' | authTranslate }}
            </div>

            <div *ngIf="getFormControl('postalCode').errors.pattern">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.postalCode.error.required' | authTranslate }}
            </div>
          </div>
        </div> <!-- postal code -->

        <div class="w-100"></div>

        <!-- email -->
        <div class="col-sm-6 form-group mb-0">
          <label for="email">{{ 'DIPRSRegistration.customerIdentification.email' | authTranslate }}</label>

          <input
            [placeholder]="'DIPRSRegistration.customerIdentification.email.placeholder' | authTranslate"
            formControlName="email"
            [dipsePatternFilter]="emailPattern"
            maxlength="50"
            id="email"
            class="form-control"
            aria-describedby="emailErrorMessage"
            [class.is-invalid]="getFormControl('email').errors &&
                                getFormControl('email').invalid &&
                                getFormControl('email').touched"
            [attr.aria-invalid]="getFormControl('email').errors &&
                                getFormControl('email').invalid &&
                                getFormControl('email').touched"
          />

          <div class="td-error" id="emailErrorMessage" role="alert"
               *ngIf="getFormControl('email').errors &&
                      getFormControl('email').invalid &&
                      getFormControl('email').touched">

            <div *ngIf="getFormControl('email').errors.required
                  || getFormControl('email').errors.email
                  || getFormControl('email').errors.pattern
                  || getFormControl('email').errors.maxlength">
              <span class="td-error-symbol" aria-hidden="true"></span>
              <span class="sr-only">{{ 'DIPRSRegistration.error.label' | authTranslate }}</span>
              {{ 'DIPRSRegistration.customerIdentification.email.error.pattern' | authTranslate }}
            </div>
          </div>
        </div> <!-- email -->

        <div class="col-12">
          <p class="mt-10 td-small-copy" [innerHTML]="'DIPRSRegistration.customerIdentification.email.introduction' | authTranslate"></p>
          <div class="row td-toolbar flex-sm-row-reverse">
            <div class="col-sm-6">
              <button type="submit" class="btn btn-block td-btn-primary-light" (click)="submit()">
                {{ 'DIPRSRegistration.customerIdentification.continue' | authTranslate }}
              </button>
            </div>
            <div class="col-sm-6">
              <button type="button" class="btn btn-block td-btn-secondary-clear" #cancelbutton (click)="cancel(cancelbutton)">
                {{ 'DIPRSRegistration.customerIdentification.cancel' | authTranslate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<dipse-loader></dipse-loader>
